module.exports = __webpack_public_path__ + "static/media/lot_head2.fd9621b4.svg";